import {
  MIN_ASSESSMENT_DURATION_SECONDS,
  SUPPORTED_FILE_SIZE,
} from './constants'

export const isValidFileExtension = (
  file: File,
  supportedExtensions: string[],
): boolean => {
  return supportedExtensions.some((ext) =>
    file.name.toLowerCase().endsWith(`.${ext.toLocaleLowerCase()}`),
  )
}

export const isValidFileSize = (file: File): boolean => {
  return file.size <= SUPPORTED_FILE_SIZE
}

/** 長さが取得できない（null）ファイルは判定できないため通す */
export const isShorterThanMinimumDuration = (
  durationSeconds: number | null,
): boolean => {
  return (
    durationSeconds != null && durationSeconds < MIN_ASSESSMENT_DURATION_SECONDS
  )
}
